import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import Loader from "../../../Components/Loader";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { AppConstants } from "../../../Constants/AppConstants";
import { getUserDetailsAPI } from "../../../Store/Action/UserAction";
import Colors from "../../../theme/Colors";
import UserRolePermissionTable from "./Controller/UserRolePermissionTable";

const UserRolePermissionList = () => {
  const searchInputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const limit = AppConstants.limit;
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState([]);
  const rowsPerPageOptions = [25, 50, 100];
  const { userData } = useSelector((state) => state.user);

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [totalCount, setTotalCount] = useState(1);

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Masters" },
      { key: "2", href: "/userList", text: Strings.userRolePermission },
    ]);
  }, []);

  useEffect(() => {
    const userRolePermissionAPI = async () => {
      try {
        const params = {
          searchQuery: null || undefined,
          page: pageNumber || undefined,
          limit: limit || undefined,
        };

        dispatch(
          getUserDetailsAPI(params, (result) => {
            setUserRole(result?.data);
            setTotalCount(result?.totalCount);

            if (searchInputRef.current) {
              searchInputRef.current.focus();
            }
          })
        );
      } catch (error) {
        console.log("Failed to fetch users:", error);
      }
    };
    userRolePermissionAPI();
  }, [dispatch, pageNumber, limit]);

  const recordAfterSorting = userRole?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  const onAddUserRolePermission = useCallback(
    (userRole) => {
      navigate("/userRolePermissionModuleList", { state: { userRole } });
    },
    [navigate]
  );

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle}>
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />

        <div style={tableContainerStyle}>
          <UserRolePermissionTable
            userRole={recordAfterSorting}
            page={pageNumber}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalItems={totalCount}
            rowsPerPageOptions={rowsPerPageOptions}
            onAddRolePermissions={onAddUserRolePermission}
          />
        </div>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const topContainerStyle = {
  backgroundColor: Colors.lightBlue,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  paddingRight: "20px",
};

const tableContainerStyle = {
  backgroundColor: "white",
  paddingTop: "20px",
  width: "98%",
  height: "70vh",
  marginTop: "15px",
  marginLeft: "20px",
};

const mainHeadingView = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: 700,
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
};

export default UserRolePermissionList;
